import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "page-wrap" }
const _hoisted_2 = { class: "grid gap-4 2xl:grid-cols-[minmax(360px,480px)_minmax(0,1fr)]" }
const _hoisted_3 = { class: "grid gap-4 md:grid-cols-2" }
const _hoisted_4 = ["value"]
const _hoisted_5 = ["value"]
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "mt-4 flex flex-wrap items-center gap-3" }
const _hoisted_8 = { class: "panel-pad min-w-0" }
const _hoisted_9 = { class: "mb-4 flex flex-col gap-3 md:flex-row md:items-center md:justify-between" }
const _hoisted_10 = {
  key: 0,
  class: "table-loading-overlay"
}
const _hoisted_11 = { class: "data-table min-w-[1480px]" }
const _hoisted_12 = { class: "divide-y divide-slate-100" }
const _hoisted_13 = { class: "font-semibold text-ink" }
const _hoisted_14 = { class: "text-right" }
const _hoisted_15 = { class: "inline-flex w-max justify-end gap-2" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "mb-4 flex items-start justify-between gap-3" }
const _hoisted_18 = { class: "text-sm text-slate-500" }
const _hoisted_19 = ["value"]
const _hoisted_20 = { class: "mt-4 flex justify-end gap-3" }
const _hoisted_21 = { class: "mb-4 flex items-start justify-between gap-3" }
const _hoisted_22 = { class: "text-sm text-slate-500" }
const _hoisted_23 = { class: "grid gap-4 md:grid-cols-2" }
const _hoisted_24 = ["value"]
const _hoisted_25 = ["value"]
const _hoisted_26 = { class: "mt-4 flex justify-end gap-3" }
const _hoisted_27 = { class: "mb-4 flex items-start justify-between gap-3" }
const _hoisted_28 = { class: "text-sm text-slate-500" }
const _hoisted_29 = { class: "text-sm font-semibold text-slate-600" }
const _hoisted_30 = { class: "font-bold text-ink" }
const _hoisted_31 = { class: "mt-4 flex justify-end gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiPageHero = _resolveComponent("UiPageHero")!
  const _component_UiInput = _resolveComponent("UiInput")!
  const _component_UiSelect = _resolveComponent("UiSelect")!
  const _component_UiButton = _resolveComponent("UiButton")!
  const _component_UiPagination = _resolveComponent("UiPagination")!
  const _component_UiModal = _resolveComponent("UiModal")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_UiPageHero, {
      eyebrow: "Thiết bị",
      title: "Tiếp nhận thiết bị",
      description: "Tạo mới, cập nhật và điều chuyển thiết bị về khoa/phòng sử dụng."
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        class: "panel-pad min-w-0",
        onSubmit: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => ($setup.createDevice && $setup.createDevice(...args)), ["prevent"]))
      }, [
        _cache[44] || (_cache[44] = _createElementVNode("p", { class: "mb-4 text-base font-bold text-ink text-left" }, " Thông tin tiếp nhận ", -1)),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_UiInput, {
            modelValue: $setup.device.maThietBi,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.device.maThietBi) = $event)),
            label: "Mã thiết bị",
            class: "md:col-span-2",
            required: ""
          }, null, 8, ["modelValue"]),
          _createVNode(_component_UiInput, {
            modelValue: $setup.device.tenThietBi,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.device.tenThietBi) = $event)),
            label: "Tên thiết bị",
            class: "md:col-span-2",
            required: ""
          }, null, 8, ["modelValue"]),
          _createVNode(_component_UiInput, {
            modelValue: $setup.device.model,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.device.model) = $event)),
            label: "Model"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_UiInput, {
            modelValue: $setup.device.hangSanXuat,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.device.hangSanXuat) = $event)),
            label: "Hãng sản xuất"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_UiInput, {
            modelValue: $setup.device.donViCungCap,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.device.donViCungCap) = $event)),
            label: "Đơn vị cung cấp"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_UiInput, {
            "model-value": $setup.giaTriInput,
            label: "Giá trị tiếp nhận",
            inputmode: "numeric",
            onKeydown: $setup.blockNonNumericKey,
            onPaste: _cache[5] || (_cache[5] = ($event: any) => ($setup.pasteNumericOnly($event, $setup.updateGiaTriTiepNhan))),
            "onUpdate:modelValue": $setup.updateGiaTriTiepNhan
          }, null, 8, ["model-value", "onKeydown", "onUpdate:modelValue"]),
          _createVNode(_component_UiInput, {
            modelValue: $setup.yearInput,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.yearInput) = $event)),
            modelModifiers: { number: true },
            label: "Năm tiếp nhận",
            type: "number",
            min: "1900",
            max: $setup.currentYear
          }, null, 8, ["modelValue", "max"]),
          _createVNode(_component_UiSelect, {
            modelValue: $setup.selectedGroup,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.selectedGroup) = $event)),
            modelModifiers: { number: true },
            label: "Nhóm thiết bị",
            onChange: $setup.loadTypes
          }, {
            default: _withCtx(() => [
              _cache[40] || (_cache[40] = _createElementVNode("option", { value: 0 }, "Chọn nhóm", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.groups, (item) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: item.id,
                  value: item.id
                }, _toDisplayString(item.tenNhomThietBi), 9, _hoisted_4))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "onChange"]),
          _createVNode(_component_UiSelect, {
            modelValue: $setup.device.idLoaiThietBi,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.device.idLoaiThietBi) = $event)),
            modelModifiers: { number: true },
            label: "Loại thiết bị",
            onChange: $setup.loadDevicesByType
          }, {
            default: _withCtx(() => [
              _cache[41] || (_cache[41] = _createElementVNode("option", { value: 0 }, "Chọn loại", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.types, (item) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: item.id,
                  value: item.id
                }, _toDisplayString(item.tenLoaiThietBi), 9, _hoisted_5))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "onChange"]),
          _createVNode(_component_UiSelect, {
            modelValue: $setup.device.loai,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.device.loai) = $event)),
            label: "Loại"
          }, {
            default: _withCtx(() => [
              _cache[42] || (_cache[42] = _createElementVNode("option", { value: "" }, "Chọn loại", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.dsLoai, (item) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: item.value,
                  value: item.value
                }, _toDisplayString(item.label), 9, _hoisted_6))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_UiButton, {
            type: "submit",
            icon: "add",
            loading: $setup.saving,
            "loading-text": "Đang lưu...",
            disabled: !$setup.canCreateDevice
          }, {
            default: _withCtx(() => [...(_cache[43] || (_cache[43] = [
              _createTextVNode("Tiếp nhận thiết bị", -1)
            ]))]),
            _: 1
          }, 8, ["loading", "disabled"])
        ])
      ], 32),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _cache[45] || (_cache[45] = _createElementVNode("p", { class: "text-base font-bold text-ink" }, "Danh sách thiết bị", -1)),
          _createVNode(_component_UiInput, {
            modelValue: $setup.query,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.query) = $event)),
            class: "w-full md:w-64",
            placeholder: "Tìm thiết bị..."
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["table-wrap max-h-[620px]", { 'is-loading': $setup.listLoading }])
        }, [
          ($setup.listLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [...(_cache[46] || (_cache[46] = [
                _createElementVNode("span", { class: "table-spinner" }, null, -1),
                _createElementVNode("span", null, "Đang tải dữ liệu...", -1)
              ]))]))
            : _createCommentVNode("", true),
          _createElementVNode("table", _hoisted_11, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("p", {
                    onClick: _cache[12] || (_cache[12] = ($event: any) => ($setup.toggleSort('tenThietBi')))
                  }, " Tên thiết bị " + _toDisplayString($setup.sortMark("tenThietBi")), 1)
                ]),
                _createElementVNode("th", null, [
                  _createElementVNode("p", {
                    onClick: _cache[13] || (_cache[13] = ($event: any) => ($setup.toggleSort('maThietBi')))
                  }, " Mã thiết bị " + _toDisplayString($setup.sortMark("maThietBi")), 1)
                ]),
                _createElementVNode("th", null, [
                  _createElementVNode("p", {
                    onClick: _cache[14] || (_cache[14] = ($event: any) => ($setup.toggleSort('namTiepNhan')))
                  }, " Năm tiếp nhận " + _toDisplayString($setup.sortMark("namTiepNhan")), 1)
                ]),
                _createElementVNode("th", null, [
                  _createElementVNode("p", {
                    onClick: _cache[15] || (_cache[15] = ($event: any) => ($setup.toggleSort('giaTriTiepNhan')))
                  }, " Nguyên giá " + _toDisplayString($setup.sortMark("giaTriTiepNhan")), 1)
                ]),
                _createElementVNode("th", null, [
                  _createElementVNode("p", {
                    onClick: _cache[16] || (_cache[16] = ($event: any) => ($setup.toggleSort('giaTriHienTai')))
                  }, " Giá trị còn lại " + _toDisplayString($setup.sortMark("giaTriHienTai")), 1)
                ]),
                _createElementVNode("th", null, [
                  _createElementVNode("p", {
                    onClick: _cache[17] || (_cache[17] = ($event: any) => ($setup.toggleSort('tyLeSuDungConLai')))
                  }, " Tỷ lệ sử dụng còn lại " + _toDisplayString($setup.sortMark("tyLeSuDungConLai")), 1)
                ]),
                _createElementVNode("th", null, [
                  _createElementVNode("p", {
                    onClick: _cache[18] || (_cache[18] = ($event: any) => ($setup.toggleSort('khoaPhongTiepNhan')))
                  }, " Khoa phòng tiếp nhận " + _toDisplayString($setup.sortMark("khoaPhongTiepNhan")), 1)
                ]),
                _createElementVNode("th", null, [
                  _createElementVNode("p", {
                    onClick: _cache[19] || (_cache[19] = ($event: any) => ($setup.toggleSort('khoaPhongHienTai')))
                  }, " Khoa phòng hiện tại " + _toDisplayString($setup.sortMark("khoaPhongHienTai")), 1)
                ]),
                _createElementVNode("th", null, [
                  _createElementVNode("p", {
                    onClick: _cache[20] || (_cache[20] = ($event: any) => ($setup.toggleSort('khoaPhongChuyenGiao')))
                  }, " Khoa phòng chuyển giao " + _toDisplayString($setup.sortMark("khoaPhongChuyenGiao")), 1)
                ]),
                _createElementVNode("th", null, [
                  _createElementVNode("p", {
                    onClick: _cache[21] || (_cache[21] = ($event: any) => ($setup.toggleSort('loai')))
                  }, "Loại " + _toDisplayString($setup.sortMark("loai")), 1)
                ]),
                _cache[47] || (_cache[47] = _createElementVNode("th", null, "Thao tác", -1))
              ])
            ]),
            _createElementVNode("tbody", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.paginatedDevices, (item) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item.id,
                  class: "hover:bg-slate-50"
                }, [
                  _createElementVNode("td", _hoisted_13, _toDisplayString(item.tenThietBi), 1),
                  _createElementVNode("td", null, _toDisplayString(item.maThietBi || "-"), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.getReceiptYear(item.thoiGianTiepNhan)), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.formatCurrency(item.giaTriTiepNhan)), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.formatCurrency(item.giaTriHienTai)), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.getRemainingUsage(item)), 1),
                  _createElementVNode("td", null, _toDisplayString(item.khoaPhongTiepNhan || "-"), 1),
                  _createElementVNode("td", null, _toDisplayString(item.khoaPhongHienTai || "-"), 1),
                  _createElementVNode("td", null, _toDisplayString(item.khoaPhongChuyenGiao || "-"), 1),
                  _createElementVNode("td", null, _toDisplayString(item.loai || item.loaiThietBi || "-"), 1),
                  _createElementVNode("td", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_UiButton, {
                        variant: "secondary",
                        size: "sm",
                        icon: "edit",
                        onClick: ($event: any) => ($setup.openUpdate(item))
                      }, {
                        default: _withCtx(() => [...(_cache[48] || (_cache[48] = [
                          _createTextVNode("Cập nhật", -1)
                        ]))]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_UiButton, {
                        variant: "secondary",
                        size: "sm",
                        icon: "transfer",
                        onClick: ($event: any) => ($setup.openTransfer(item))
                      }, {
                        default: _withCtx(() => [...(_cache[49] || (_cache[49] = [
                          _createTextVNode("Chuyển", -1)
                        ]))]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_UiButton, {
                        variant: "danger",
                        size: "sm",
                        icon: "delete",
                        onClick: ($event: any) => ($setup.openDelete(item))
                      }, {
                        default: _withCtx(() => [...(_cache[50] || (_cache[50] = [
                          _createTextVNode("Xóa", -1)
                        ]))]),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ])
                ]))
              }), 128)),
              (!$setup.filteredDevices.length)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_16, [...(_cache[51] || (_cache[51] = [
                    _createElementVNode("td", {
                      colspan: "11",
                      class: "py-10 text-center text-slate-500"
                    }, " Chưa có thiết bị. ", -1)
                  ]))]))
                : _createCommentVNode("", true)
            ])
          ])
        ], 2),
        _createVNode(_component_UiPagination, {
          modelValue: $setup.page,
          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (($setup.page) = $event)),
          total: $setup.filteredDevices.length,
          "page-size": $setup.pageSize
        }, null, 8, ["modelValue", "total", "page-size"])
      ])
    ]),
    ($setup.transferOpen)
      ? (_openBlock(), _createBlock(_component_UiModal, { key: 0 }, {
          default: _withCtx(() => [
            _createElementVNode("form", {
              onSubmit: _cache[26] || (_cache[26] = _withModifiers(
//@ts-ignore
(...args) => ($setup.transferDevice && $setup.transferDevice(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", null, [
                  _cache[52] || (_cache[52] = _createElementVNode("p", { class: "text-xl font-bold text-ink" }, "Chuyển thiết bị", -1)),
                  _createElementVNode("p", _hoisted_18, _toDisplayString($setup.selectedDeviceName), 1)
                ]),
                _createVNode(_component_UiButton, {
                  variant: "ghost",
                  size: "sm",
                  icon: "close",
                  onClick: _cache[23] || (_cache[23] = ($event: any) => ($setup.transferOpen = false))
                }, {
                  default: _withCtx(() => [...(_cache[53] || (_cache[53] = [
                    _createTextVNode("Đóng", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _createVNode(_component_UiSelect, {
                modelValue: $setup.transferDepartmentId,
                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (($setup.transferDepartmentId) = $event)),
                modelModifiers: { number: true },
                label: "Khoa/phòng nhận",
                required: ""
              }, {
                default: _withCtx(() => [
                  _cache[54] || (_cache[54] = _createElementVNode("option", { value: 0 }, "Chọn khoa/phòng", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.departments, (item) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: item.id,
                      value: item.id
                    }, _toDisplayString(item.tenKhoaPhong), 9, _hoisted_19))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_UiButton, {
                  variant: "secondary",
                  icon: "cancel",
                  onClick: _cache[25] || (_cache[25] = ($event: any) => ($setup.transferOpen = false))
                }, {
                  default: _withCtx(() => [...(_cache[55] || (_cache[55] = [
                    _createTextVNode("Hủy", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_UiButton, {
                  type: "submit",
                  icon: "transfer",
                  disabled: !$setup.transferDepartmentId
                }, {
                  default: _withCtx(() => [...(_cache[56] || (_cache[56] = [
                    _createTextVNode("Xác nhận chuyển", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled"])
              ])
            ], 32)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    ($setup.updateOpen)
      ? (_openBlock(), _createBlock(_component_UiModal, { key: 1 }, {
          default: _withCtx(() => [
            ($setup.updateDevice)
              ? (_openBlock(), _createElementBlock("form", {
                  key: 0,
                  onSubmit: _cache[38] || (_cache[38] = _withModifiers(
//@ts-ignore
(...args) => ($setup.submitUpdateDevice && $setup.submitUpdateDevice(...args)), ["prevent"]))
                }, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", null, [
                      _cache[57] || (_cache[57] = _createElementVNode("p", { class: "text-xl font-bold text-ink" }, "Cập nhật thiết bị", -1)),
                      _createElementVNode("p", _hoisted_22, _toDisplayString($setup.updateDevice.tenThietBi), 1)
                    ]),
                    _createVNode(_component_UiButton, {
                      variant: "ghost",
                      size: "sm",
                      icon: "close",
                      onClick: _cache[27] || (_cache[27] = ($event: any) => ($setup.updateOpen = false))
                    }, {
                      default: _withCtx(() => [...(_cache[58] || (_cache[58] = [
                        _createTextVNode("Đóng", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(_component_UiInput, {
                      modelValue: $setup.updateDevice.maThietBi,
                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (($setup.updateDevice.maThietBi) = $event)),
                      label: "Mã thiết bị",
                      class: "md:col-span-2",
                      required: ""
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_UiInput, {
                      modelValue: $setup.updateDevice.tenThietBi,
                      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (($setup.updateDevice.tenThietBi) = $event)),
                      label: "Tên thiết bị",
                      class: "md:col-span-2",
                      required: ""
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_UiInput, {
                      modelValue: $setup.updateDevice.model,
                      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (($setup.updateDevice.model) = $event)),
                      label: "Model",
                      required: ""
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_UiInput, {
                      modelValue: $setup.updateDevice.hangSanXuat,
                      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (($setup.updateDevice.hangSanXuat) = $event)),
                      label: "Hãng sản xuất",
                      required: ""
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_UiInput, {
                      modelValue: $setup.updateDevice.donViCungCap,
                      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => (($setup.updateDevice.donViCungCap) = $event)),
                      label: "Đơn vị cung cấp",
                      required: ""
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_UiInput, {
                      "model-value": $setup.updateGiaTriInput,
                      label: "Giá trị tiếp nhận",
                      inputmode: "numeric",
                      onKeydown: $setup.blockNonNumericKey,
                      onPaste: _cache[33] || (_cache[33] = ($event: any) => ($setup.pasteNumericOnly($event, $setup.updateGiaTriCapNhat))),
                      "onUpdate:modelValue": $setup.updateGiaTriCapNhat
                    }, null, 8, ["model-value", "onKeydown", "onUpdate:modelValue"]),
                    _createVNode(_component_UiInput, {
                      modelValue: $setup.updateYearInput,
                      "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (($setup.updateYearInput) = $event)),
                      modelModifiers: { number: true },
                      label: "Năm tiếp nhận",
                      type: "number",
                      min: "1900",
                      max: $setup.currentYear
                    }, null, 8, ["modelValue", "max"]),
                    _createVNode(_component_UiSelect, {
                      modelValue: $setup.updateSelectedGroup,
                      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (($setup.updateSelectedGroup) = $event)),
                      modelModifiers: { number: true },
                      label: "Nhóm thiết bị",
                      onChange: $setup.loadUpdateTypes
                    }, {
                      default: _withCtx(() => [
                        _cache[59] || (_cache[59] = _createElementVNode("option", { value: 0 }, "Chọn nhóm", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.groups, (item) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: item.id,
                            value: item.id
                          }, _toDisplayString(item.tenNhomThietBi), 9, _hoisted_24))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange"]),
                    _createVNode(_component_UiSelect, {
                      modelValue: $setup.updateDevice.idLoaiThietBi,
                      "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => (($setup.updateDevice.idLoaiThietBi) = $event)),
                      modelModifiers: { number: true },
                      label: "Loại thiết bị"
                    }, {
                      default: _withCtx(() => [
                        _cache[60] || (_cache[60] = _createElementVNode("option", { value: 0 }, "Chọn loại", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.updateTypes, (item) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: item.id,
                            value: item.id
                          }, _toDisplayString(item.tenLoaiThietBi), 9, _hoisted_25))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createVNode(_component_UiButton, {
                      variant: "secondary",
                      icon: "cancel",
                      onClick: _cache[37] || (_cache[37] = ($event: any) => ($setup.updateOpen = false))
                    }, {
                      default: _withCtx(() => [...(_cache[61] || (_cache[61] = [
                        _createTextVNode("Hủy", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_UiButton, {
                      type: "submit",
                      icon: "save",
                      loading: $setup.updating,
                      "loading-text": "Đang cập nhật...",
                      disabled: !$setup.canUpdateDevice
                    }, {
                      default: _withCtx(() => [...(_cache[62] || (_cache[62] = [
                        _createTextVNode("Cập nhật", -1)
                      ]))]),
                      _: 1
                    }, 8, ["loading", "disabled"])
                  ])
                ], 32))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    ($setup.deleteDeviceTarget)
      ? (_openBlock(), _createBlock(_component_UiModal, { key: 2 }, {
          default: _withCtx(() => [
            _createElementVNode("form", {
              onSubmit: _cache[39] || (_cache[39] = _withModifiers(
//@ts-ignore
(...args) => ($setup.deleteDevice && $setup.deleteDevice(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", null, [
                  _cache[63] || (_cache[63] = _createElementVNode("p", { class: "text-xl font-bold text-ink" }, "Xóa thiết bị", -1)),
                  _createElementVNode("p", _hoisted_28, _toDisplayString($setup.deleteDeviceName), 1)
                ]),
                _createVNode(_component_UiButton, {
                  variant: "ghost",
                  size: "sm",
                  icon: "close",
                  onClick: $setup.closeDelete
                }, {
                  default: _withCtx(() => [...(_cache[64] || (_cache[64] = [
                    _createTextVNode(" Đóng ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _createElementVNode("p", _hoisted_29, [
                _cache[65] || (_cache[65] = _createTextVNode(" Bạn có chắc chắn muốn xóa thiết bị ", -1)),
                _createElementVNode("span", _hoisted_30, _toDisplayString($setup.deleteDeviceName), 1),
                _cache[66] || (_cache[66] = _createTextVNode(" không? ", -1))
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createVNode(_component_UiButton, {
                  type: "button",
                  variant: "secondary",
                  icon: "cancel",
                  onClick: $setup.closeDelete
                }, {
                  default: _withCtx(() => [...(_cache[67] || (_cache[67] = [
                    _createTextVNode(" Hủy ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_UiButton, {
                  type: "submit",
                  variant: "danger",
                  icon: "delete",
                  loading: $setup.deletingDevice
                }, {
                  default: _withCtx(() => [...(_cache[68] || (_cache[68] = [
                    _createTextVNode(" Xác nhận xóa ", -1)
                  ]))]),
                  _: 1
                }, 8, ["loading"])
              ])
            ], 32)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}